export default __webpack_public_path__ + "static/media/icons-bar-next-normal-18-px.304df1af.svg";